import { FormStep } from '@sec-loans-ui/loan-offer/steps/FormStep'
import { useWizardForm } from '@ui-common/hooks'
import { FormSectionContainer } from '@ui-components/form/FormSectionContainer'
import { BodyText } from '@ui-components/typography/Typography'
import { useIntl } from 'react-intl'
import { styled } from 'styled-components'

import { ReservationFooter } from '../../components/ReservationFooter'
import { useExistingLoanOfferContext } from '../LoanOfferContext'

const ConditionList = styled.ul`
  list-style-type: square;
  list-style-position: outside;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-left: 24px;
`

export const TermsInfoStep = () => {
  const { formatMessage } = useIntl()
  const { proceed, loanOffer } = useExistingLoanOfferContext()

  const methods = useWizardForm({
    defaultValues: loanOffer,
  })

  const conditionList =
    loanOffer?.offerConditions?.map((offerCondition, index) => {
      return <li key={index}>{offerCondition.description}</li>
    }) || []

  return (
    <FormStep
      allowBack={true}
      subHeader={formatMessage({ id: 'loan-offer-terms-info-step-heading' })}
      formMethods={methods}
      onSubmit={proceed}
      customFooter={
        <ReservationFooter loanOfferMode={loanOffer.loanOfferMode} reservationLink={loanOffer.reservationLink} />
      }
    >
      <FormSectionContainer>
        <div>
          <BodyText tagName={'p'}>{formatMessage({ id: 'loan-offer-terms-and-conditions-1' })}</BodyText>
          <BodyText tagName={'p'}>{formatMessage({ id: 'loan-offer-terms-and-conditions-2' })}</BodyText>
          <BodyText tagName={'p'}>{formatMessage({ id: 'loan-offer-terms-and-conditions-3' })}</BodyText>
        </div>
        {conditionList.length ? <ConditionList data-testid={'conditionList'}>{conditionList}</ConditionList> : null}
      </FormSectionContainer>
    </FormStep>
  )
}
